import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=01285af5&scoped=true&"
import script from "./BaseFormField.vue?vue&type=script&lang=ts&"
export * from "./BaseFormField.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFormField.vue?vue&type=style&index=0&id=01285af5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01285af5",
  null
  
)

export default component.exports